import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { DomainRefresh } from '../ContentRefresh/types'

type ReturnType = {
  data: DomainRefresh
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: unknown
}

const handleApiRequest = async (companyId: string, domainId?: string) => {
  try {
    const response = await axios.get(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-refresh/domains/${domainId}`
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useGetDomainRefreshParams = ({
  companyId,
  isEnabled = false,
  domainId,
}: {
  companyId: string
  isEnabled: boolean
  domainId?: string
}): ReturnType => {
  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryFn: () => handleApiRequest(companyId, domainId),
    queryKey: ['content-gap-domain-refresh-params', companyId, domainId],
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  return {
    data: response?.data,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}
